import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import SbImageService, { isSvg } from "../../helpers/SbImageService"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import Components from "../index"

class SectionSplit extends Component {
  render() {
    const { blok } = this.props
    return (
      <SbEditable content={blok}>
        <section
          id={`section-${blok._uid}`}
          className={`section-split${
            blok.section_color ? " section-split" : ""
          }${blok.section_color}`}
        >
          <div className="section-split__container container">
            <div className="section-split__left">
              {blok.anchor && (
                <p className="section-split__anchor">{blok.anchor}</p>
              )}
              {blok.title && (
                <h2
                  className={`section-split__heading heading ${
                    blok.accent ? " heading--accent" : ""
                  }`}
                >
                  {blok.title}
                </h2>
              )}
              {blok.copy && (
                <div className="section-split__copy">
                  {
                    unified()
                      .use(remarkParse)
                      .use(remarkRehype)
                      .use(rehypeReact, {
                        createElement: React.createElement,
                        components: remarkReactComponents,
                        Fragment: React.Fragment
                      })
                      .processSync(blok.copy).result
                  }
                </div>
              )}
              {blok.body.length > 0 && (
                <div
                  className={`section-split__body ${
                    !blok.title && !blok.copy
                      ? "section-split__body--no-margin"
                      : ""
                  }`}
                >
                  {blok.body &&
                    blok.body.map((c) =>
                      React.createElement(Components(c.component), {
                        key: c._uid,
                        blok: c,
                      })
                    )}
                </div>
              )}
            </div>
            <div
              className="lazyload section-split__right"
              data-bg={SbImageService(blok.image.filename)}
              style={isSvg(blok.image.filename) ? blok.image.filename : null}
            ></div>
          </div>
        </section>
      </SbEditable>
    )
  }
}

SectionSplit.propTypes = {
  blok: PropTypes.shape({
    _uid: PropTypes.string,
    anchor: PropTypes.string,
    title: PropTypes.string,
    copy: PropTypes.string,
    body: PropTypes.arrayOf(PropTypes.object),
    accent: PropTypes.bool,
    section_padding: PropTypes.string,
  }).isRequired,
}

export default SectionSplit
